t = require('views/internal/teacup-with-helpers')('board_observer_count')

module.exports = ->
  t.a '.quiet-button.js-show-observers', { href: '#', style: 'margin: 4px 0 0;' }, ->
    t.text t.mustacheVar('localizedObserverCount')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_observer_count.coffee